import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./QuoteAttribution.css";

class QuoteAttribution extends Component {
  render() {
    const { block, extras } = this.props;
    const isStyledQ = extras.styledQuoteAttributions.includes(block.key);
    return (
      <div className={classNames(styles.root, isStyledQ ? styles.centered : {})}>
        {`${block.text && "— "}${this.props.children}`}
      </div>
    );
  }
}

QuoteAttribution.propTypes = {
  block: PropTypes.object.isRequired,
  extras: PropTypes.object.isRequired,
};

export default QuoteAttribution;
